const Groups = [{
  id: 10,
  name: '10 Group (SW England)',
}, {
  id: 11,
  name: '11 Group (SE England)',
}, {
  id: 12,
  name: '12 Group (Midlands)',
}, {
  id: 13,
  name: '13 Group (North)',
}];
export default Groups;
